// Handles copy/share product link button
export function initProductShare({ copyLinkButton }) {
    if (!copyLinkButton) return;
    copyLinkButton.addEventListener('click', handleCopyLink);

    async function handleCopyLink(event) {
        event.preventDefault();
        const url = window.location.href;
        try {
            if (navigator.share) {
                await navigator.share({
                    title: document.title,
                    text: copyLinkButton.dataset.shareDesc,
                    url: url
                });
                return;
            } else {
                await navigator.clipboard.writeText(url);
                const copyButtonTooltip = copyLinkButton.querySelector('span');
                if (!copyButtonTooltip) return;
                copyButtonTooltip.classList.remove('hidden');
                setTimeout(() => {
                    copyButtonTooltip.classList.add('hidden');
                }, 3000);
            }
        } catch (err) {
            // Optionally log or handle error
        }
    }
}
